<div
  *ngIf="isOpen"
  class="fixed inset-0 wallet-modal-backdrop flex items-center justify-center z-[999] px-3 sm:px-4"
  (click)="onCancel.emit()"
>
  <div
    class="wallet-modal-shell w-full max-w-md text-center"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-end mb-5">
      <button (click)="onCancel.emit()" class="wallet-modal-close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Profile image -->
    <div class="flex justify-center mb-5">
      <div class="relative">
        <div
          class="absolute inset-0 rounded-full blur-md opacity-40"
          style="background: linear-gradient(135deg, #E7C98B, #F2A56F, #d946ef);"
        ></div>
        <img loading="lazy"
          [src]="profileImage || '/avatar.png'"
          alt="Profile"
          class="relative w-24 h-24 rounded-full object-cover border-2 border-white/20"
          onerror="this.src='/avatar.png'"
        />
      </div>
    </div>

    <p class="text-white text-lg font-semibold mb-2">
      Are you sure you want to Logout?
    </p>
    <p class="text-sm text-[var(--modal-text-muted)] mb-6">
      You will be signed out of your Luckycrest account.
    </p>

    <!-- Buttons -->
    <div class="flex flex-col sm:flex-row gap-3 w-full">
      <button (click)="onCancel.emit()" class="wallet-btn-cancel">
        Cancel
      </button>
      <button (click)="onConfirm.emit()" class="wallet-btn-action">
        <svg
          class="w-4 h-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
          <path d="M16 17l5-5-5-5" />
          <path d="M21 12H9" />
        </svg>
        Logout
      </button>
    </div>
  </div>
</div>
